import React from 'react';
import styles from './BannerTitle.module.css';

const BannerTitle = ({ title1, title2 }) => {

    return (
        <>
            <h2 className={styles.title}><span >{title1}</span> <span className={styles.title2}>{title2}</span></h2>
        </>
    );
};

export default BannerTitle;